module.exports = __webpack_public_path__ + "media/images/countrysquared/hn-3c3b99a449c238b2a35fd39f5b43c1fd.svg";